import { useStore } from '@/store';
import { computed } from 'vue'

const useLibrary = () => {
  const store = useStore();

  const incAddToPageLibrary = () => {
    store.state.library.countAddToPageLibrary = store.state.library.countAddToPageLibrary + 1
  }

  return {
    incAddToPageLibrary,
    totalAddToPageLibrary: computed(() => store.state.library.countAddToPageLibrary),
    numberUseAddToPage: computed(() => store.state.library.numberUseAddToPage)
  }
}

export { useLibrary as default }
